import { memo as d, useRef as g, useMemo as b, useLayoutEffect as u } from "react";
import { DynamicDrawUsage as M } from "three";
import { getAbstractMeshProps as x } from "./index2.js";
import { updateAbstractSiteInstaMesh as y } from "./index3.js";
import { changeColorFuncUkV1V2 as A } from "../../colors/internal/index.js";
import { jsxs as o, Fragment as f, jsx as t } from "react/jsx-runtime";
const l = d(({
  obj: a,
  children: m,
  colourFunc: c = A,
  emissive: i = "#000000",
  ...h
}) => {
  const r = g(null), {
    matrices: e,
    colors: n,
    extrudeGeometries: p
  } = b(() => x({
    obj: a,
    colourFunc: c
  }), [a, c]);
  return u(() => {
    !r.current || r.current.instanceMatrix.setUsage(M);
  }, []), u(() => {
    !r.current || y({
      mesh: r.current,
      matrices: e,
      colors: n
    });
  }, [e, n]), /* @__PURE__ */ o(f, {
    children: [!!e.length && /* @__PURE__ */ o("instancedMesh", {
      ref: r,
      args: [void 0, void 0, e.length],
      ...h,
      children: [m, !m && /* @__PURE__ */ o(f, {
        children: [/* @__PURE__ */ t("boxGeometry", {
          args: [1, 1, 1]
        }), /* @__PURE__ */ t("meshLambertMaterial", {
          color: "#fff",
          emissive: i
        })]
      })]
    }), p.map((s) => /* @__PURE__ */ t("mesh", {
      geometry: s,
      children: /* @__PURE__ */ t("meshLambertMaterial", {
        color: s.userData.color,
        emissive: i
      })
    }, s.uuid))]
  });
});
l.displayName = "AbstractViewFC";
const U = l;
export {
  U as AbstractSiteFC,
  l as AbstractViewFC
};
//# sourceMappingURL=index.js.map
